import { ChangeDetectionStrategy, Component, inject, OnInit } from '@angular/core';
import { SidebarComponent } from '../sidebar/sidebar.component';
import { MenuItem } from 'primeng/api';
import { CommonModule } from '@angular/common';
import { Router } from '@angular/router';
import { PRIME_FORM_MODULES } from '../../prime-ng/prime-forms.imports';
import { PRIME_MISC_MODULES } from '../../prime-ng/prime-misc.imports';
import { AuthStore } from 'src/app/core/store/auth.store';

@Component({
  selector: 'shared-navbar',
  imports: [
    ...PRIME_FORM_MODULES,
    ...PRIME_MISC_MODULES,
    SidebarComponent, 
    CommonModule],
  templateUrl: './navbar.component.html',
  styleUrl: './navbar.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NavbarComponent implements OnInit {
  
  public items: MenuItem[] | undefined;

  public store = inject(AuthStore);
  private router = inject(Router)
  ngOnInit() {
      this.items = [
        {
          label: 'Cerrar Sesion',
          icon: 'pi pi-sign-out',
          command: () => {
            this.onSingOut();
        }
        }
      ];
  }

  async onSingOut(): Promise<void> {
    await this.store.logout();
    this.router.navigateByUrl('/auth');
  }
}
